import React from "react";

import facebook_icon from "../../Images/LOGO/facebook.png";

import message from "../../icons/gmail.png";

export default function Footer() {
  // const sendmail=()=>{
  //     Email.send({
  //         Host : "smtp.elasticemail.com",
  //         Username : "username",
  //         Password : "password",
  //         To : 'them@website.com',
  //         From : "you@isp.com",
  //         Subject : "This is the subject",
  //         Body : "And this is the body"
  //     }).then(
  //       message => alert(message)
  //     );
  // }

  return (
    <>
      <section className="footer-section-homepage">
        <div
          className="container"
          style={{
            backgroundColor: "black",
            marginTop: 10 + "vh",
            height: "justify",
            marginBottom: 2 + "vh",
          }}
        >
          <div className="container text-center">
            <div className="row">
              {/* ----------------------------------- first column --------------------------------------------------*/}
              <div className="col col-lg-12 col-md-12 col-sm-12">
                <div
                  className="container text-center"
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  <h1
                  style={{marginBottom: 4+'vh',
                    letterSpacing:3+'px',
                    fontSize: 3+'rem',
                    marginTop: 2+'px',
                    fontFamily:" monospace"}}
                    className="contact-us-heading-footer"

                  >
                    Contact Us
                  </h1>
                  <div className="col">
                    <div className="container-fluid follow-now-on">
                      <div className="container text-center container-icon ">
                        {/* <img src={facebook_icon} alt="" className='icon-footer-section' /> */}
                        <a href="https://www.facebook.com/profile.php?id=100001880954238">
                          <img
                            src={facebook_icon}
                            alt=""
                            className="icon-footer-section"
                            
                          />
                        </a>
                        <a href="https://api.whatsapp.com/send/?phone=%2B917073411116&text&type=phone_number&app_absent=0">
                          <img
                            src="https://raw.githubusercontent.com/github/explore/fbea3555736cd38170cc0be88424d129741ffbb9/topics/whatsapp/whatsapp.png"
                            alt=""
                            className="icon-footer-section"
                            style={{height:50+'px'}}
                          ></img>
                        </a>
                        <a href="https://mail.google.com/mail/u/0/?fs=1&to=devbki2003@outlook.com&su=SUBJECT&body=BODY&tf=cm">
                          <img
                            src={message}
                            alt=""
                            className="icon-footer-section"
                           
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="copyrights" style={{ marginTop: 40 + "px" }}>
                <b>
                  <p
                    className="founders"
                    style={{ marginBottom: 2 + "vh", fontSize: 4 + "vh" }}
                  >
                    Founder's
                  </p>
                </b>{" "}
                Mr. Manoj Kumar Sharma <br />
                Mr. Devanshu Sharma <br />
                <br />
                Copyrights (C) 2023 <b>Dev Computers & Founders</b>
              </p>
              {/* ----------------------------------- second column --------------------------------------------------*/}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
